module.exports = __webpack_public_path__ + "static/media/img-background3.4716643e.jpg";